<script lang="ts" setup>
  import MainNavAccountMenu from '@/components/landingPage/nav/MainNavAccountMenu.vue'
  import type { JwtContent } from '@/types'
  import { useDisplay } from 'vuetify'
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useTypedRoute } from '@/composables'

  const { t } = useI18n()

  const props = defineProps<{
    cartItems: number
    loggedIn: boolean
    jwt: JwtContent
  }>()

  const emits = defineEmits<{
    (e: 'logout', bool: boolean): void
  }>()

  const { mobile } = useDisplay()
  const route = useTypedRoute<{ id: string }>()
  const isLoggedIn = computed(() => props.loggedIn)
  const cartItemsCount = computed(() => props.cartItems)

  const handleLogout = (e: boolean) => {
    emits('logout', e)
  }

  const cartBtnStyle = computed(() => {
    if (!mobile.value && route.fullPath.includes('/cart')) {
      return {
        boxSizing: 'border-box',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        color: 'rgba(0, 0, 0, 1)',
        borderRight: '1px solid rgba(255, 255, 255, 0.5)',
        borderLeft: '1px solid rgba(255, 255, 255, 0.5)'
      } as Record<string, string>
    }
    return undefined
  })
</script>

<template>
  <v-sheet class="d-flex justify-end align-center" color="transparent">
    <v-tooltip text="Kontakt" location="bottom">
      <template #activator="{ props }">
        <v-btn v-bind="props" class="me-2 d-none d-sm-flex" href="mailto:service@itsh.dev" icon variant="text" aria-label="Kontakt">
          <v-icon icon="mdi-email-outline" />
        </v-btn>
      </template>
    </v-tooltip>

    <v-btn
      v-if="cartItemsCount > 0"
      :style="cartBtnStyle"
      :to="{ name: isLoggedIn ? 'dashboardCart' : 'cart' }"
      replace
      icon
      variant="text"
      class="me-1"
      :aria-label="t('a11y.shoppingCart')"
    >
      <v-badge :content="cartItemsCount" color="primary">
        <v-icon class="cart-icon" icon="mdi-cart" />
      </v-badge>
    </v-btn>

    <v-sheet v-if="isLoggedIn" :width="mobile ? '100%' : ''" color="transparent">
      <main-nav-account-menu v-if="isLoggedIn" :jwt="props.jwt" @logout="handleLogout" />
    </v-sheet>
    <v-tooltip v-else text="Login" location="bottom">
      <template #activator="{ props }">
        <v-btn v-bind="props" :to="{ name: 'login' }" replace icon aria-label="Login">
          <v-icon icon="mdi-account" />
        </v-btn>
      </template>
    </v-tooltip>
  </v-sheet>
</template>

<style lang="scss" scoped>
  img {
    height: 30px;
  }
  .cart-icon {
    font-size: 24px;
  }
</style>
